import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/logo_primary_mobile.png'
import _imports_1 from '@/assets/images/logo_btm.png'


const _withScopeId = n => (_pushScopeId("data-v-75a33955"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = {
  key: 0,
  class: "logo_mobile"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "logo_desktop"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "burger_menu"
}
const _hoisted_9 = { class: "hamburger-menu" }
const _hoisted_10 = {
  key: 1,
  class: "flex w-full pl-10"
}

import { useWindowSize } from '@vueuse/core';
import { toRefs, ref } from 'vue';
import { useGlobalStore } from '@/stores/global';
import LocaleSwitcher from '@/components/common/LocaleSwitcher.vue';
import NavMenu from '@/components/common/NavMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeader',
  setup(__props) {

const globalStore = useGlobalStore();
const { isMainPage } = toRefs(globalStore);

const { width } = useWindowSize();

const toggle = ref<boolean>(false);

const toggleMenu = () => {
    toggle.value = !toggle.value;
    const body = document.querySelector('body');
    if (body) {
        if (toggle.value) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = 'auto';
        }
    }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["header_container", {
                menu_active: toggle.value,
                '!bg-[var(--base-white)] border-b': !_unref(isMainPage),
            }])
    }, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          (_unref(width) < 1024)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        ]),
        _: 1
      }),
      (_unref(width) < 1024)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toggle).value = $event)),
                type: "checkbox",
                onClick: toggleMenu
              }, null, 512), [
                [_vModelCheckbox, toggle.value]
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(NavMenu),
            _createVNode(LocaleSwitcher, {
              class: "ml-auto",
              color: "var(--black-color)"
            })
          ]))
    ], 2),
    _createElementVNode("menu", {
      class: _normalizeClass(["menu sidebar", {
                '!bg-[var(--base-white)]': toggle.value,
                active: toggle.value,
            }])
    }, [
      _createVNode(NavMenu, { onClose: toggleMenu })
    ], 2)
  ]))
}
}

})